import { Box, Card, Skeleton } from '@mui/material';

const GridSkeleton = () => {
    return (
        <Box
            display="grid"
            gap={2}
            gridTemplateColumns="repeat(auto-fill, minmax(218px, 1fr))"
        >
            {[...Array(12)].map((_, index) => (
                <Card key={index}>
                    <Skeleton variant="rectangular" height={300} />
                </Card>
            ))}
        </Box>
    );
};

export default GridSkeleton;
